/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';

import Carousel from 'app/components/commons/Carousel';
import Responsive from 'app/components/responsive/Responsive';
import NoHistory from './NoHistory';
import FormBox from './FormBox';

type Props = {
  games: Array<*>,
  maxScore?: number,
  name: string,
  isSmall: boolean
};

const Wrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.white,
  color: theme.color.basis4,
  display: 'flex',
  flexDirection: 'column'
}));

const StyledFormBox = styled(FormBox)(({ opacity }) => ({
  opacity
}));

class FormLine extends React.Component<Props> {
  props: Props;

  state: State;

  static defaultProps = {
    maxScore: undefined
  };

  render() {
    const { games, maxScore, name, isSmall } = this.props;

    if (games.length === 0) {
      return <NoHistory name={name} />;
    }

    return (
      <Wrapper>
        <Responsive mobile tabletPortrait={false}>
          {isSmallScreen => (
            <Carousel
              initialPosition={0}
              slidesToScroll={isSmall || isSmallScreen ? 6 : 10}
              slidesToShow={isSmall || isSmallScreen ? 6 : 10}
            >
              {games.map((gm, i) => (
                <StyledFormBox
                  key={gm.id}
                  label={moment(gm.startTime).format('DD MMM')}
                  maximum={maxScore}
                  score={gm.score}
                  opacity={Math.max(1 - i / 20, 0.5)}
                  isSmall={isSmall}
                />
              ))}
            </Carousel>
          )}
        </Responsive>
      </Wrapper>
    );
  }
}

export default FormLine;
